import { checkShouldUseMocks } from '@telialt/utils/src/envUtils';
import { MS_URL } from '@telialt/utils/src/microservices';

export const API = {
    FOOTER: `${MS_URL}/api/v3/content/layouts`,
};

if (checkShouldUseMocks({ shouldUseInTest: true })) {
    API.FOOTER = '/api/nav/footer';
}
